export default class ActionValueModel {
    public id: string;
    public weight: number;
    public multiplier: number;
    public conditions: string[];
}